/**
 * Skeleton Components for Customer Module
 * 
 * Migrated from seo-engine-webtools-customer-module
 */

import { Card, CardContent, Skeleton, Box, Grid } from '@mui/material';

// MetricCard Skeleton
export function MetricCardSkeleton() {
  return (
    <Card>
      <CardContent>
        <Skeleton variant="text" width="70%" height={20} sx={{ mb: 1 }} />
        <Skeleton variant="text" width="50%" height={48} sx={{ mb: 1 }} />
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Skeleton variant="circular" width={20} height={20} />
          <Skeleton variant="text" width={60} height={20} />
          <Skeleton variant="text" width={80} height={16} />
        </Box>
      </CardContent>
    </Card>
  );
}

// Table Skeleton
interface TableSkeletonProps {
  rows?: number;
  columns?: number;
}

export function TableSkeleton({ rows = 10, columns = 5 }: TableSkeletonProps) {
  return (
    <Card>
      <CardContent>
        <Box sx={{ mb: 2 }}>
          <Skeleton variant="rectangular" width="100%" height={40} sx={{ borderRadius: 1 }} />
        </Box>
        {Array.from({ length: rows }).map((_, rowIndex) => (
          <Box key={rowIndex} sx={{ display: 'flex', gap: 2, mb: 1.5, alignItems: 'center' }}>
            {Array.from({ length: columns }).map((_, colIndex) => (
              <Skeleton 
                key={colIndex} 
                variant="text" 
                width={`${100 / columns}%`} 
                height={24} 
              />
            ))}
          </Box>
        ))}
      </CardContent>
    </Card>
  );
}

// Chart Skeleton
interface ChartSkeletonProps {
  height?: number;
  variant?: 'line' | 'bar' | 'pie';
}

export function ChartSkeleton({ height = 300, variant = 'line' }: ChartSkeletonProps) {
  return (
    <Card>
      <CardContent>
        <Skeleton variant="text" width="30%" height={28} sx={{ mb: 2 }} />
        {variant === 'pie' ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height }}>
            <Skeleton variant="circular" width={200} height={200} />
          </Box>
        ) : (
          <Skeleton variant="rectangular" height={height} sx={{ borderRadius: 1 }} />
        )}
      </CardContent>
    </Card>
  );
}

// Dashboard Skeleton
export function DashboardSkeleton() {
  return (
    <Box>
      <Box sx={{ mb: 4 }}>
        <Skeleton variant="text" width={250} height={40} />
        <Skeleton variant="text" width={350} height={24} />
      </Box>

      <Grid container spacing={3}>
        <Grid item xs={12} md={4}>
          <Card>
            <CardContent>
              <Skeleton variant="text" width="60%" height={32} />
              <Skeleton variant="rectangular" height={200} sx={{ mt: 2, borderRadius: 1 }} />
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} md={8}>
          <Grid container spacing={2}>
            {[1, 2, 3, 4].map((i) => (
              <Grid item xs={12} sm={6} key={i}>
                <MetricCardSkeleton />
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
}

export default {
  MetricCardSkeleton,
  TableSkeleton,
  ChartSkeleton,
  DashboardSkeleton,
};
